function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m6.5 17.875-3.25 3.185v-9.1433h3.25v5.9583zm5.4167-1.9933-1.7009-1.4517-1.5491 1.43v-8.2767h3.25v8.2984zm5.4166-1.7984-3.25 3.25v-14.083h3.25v10.833zm3.0442-0.2058-1.9608-1.9608h5.4166v5.4166l-1.9391-1.9391-7.8109 7.7458-3.7591-3.2717-4.095 3.965h-2.9792l7.0092-6.8683 3.8241 3.2283",
  fill: "currentColor"
});
function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.2/media/stats.d706b178.svg";
export { SvgStats as ReactComponent };